<template>
  <div class="success-page">
    <div class="content-wrapper">
      <div class="tick-mark"></div>
      <h1>Your site has been<br>added successfully!</h1>
      <div class="button-container">
        <button class="view-site-button" @click="viewSite">View Site</button>
        <button class="add-device-button" @click="addDevice">Add Device</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';

export default {
  name: 'SiteSummary',

  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    viewSite() {
      console.log('View Site button clicked');
      this.$router.push({ path: '/homepage', query: { view: 'SitePage', component: 'SiteList' } });
    },
    addDevice() {
      console.log('Add Device button clicked');
      this.$router.push('/connect_to_inverter');
    }
  }
};
</script>

<style scoped>
.success-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: rgb(6, 4, 37);
  font-family: 'Montserrat', sans-serif;
}

.content-wrapper {
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

h1 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #453a94;
}

.tick-mark {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgb(6, 4, 37);
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tick-mark::after {
  content: '';
  width: 15px;
  height: 30px;
  border: solid white;
  border-width: 0 5px 5px 0;
  transform: rotate(45deg);
  opacity: 0;
  animation: tick-animation 2.5s ease-in-out forwards;
}

@keyframes tick-animation {
  to {
    opacity: 1;
  }
}

.button-container {
  display: flex;
  gap: 10px;
}

.view-site-button,
.add-device-button {
  background-color: #453a94;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 7px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.view-site-button:hover,
.add-device-button:hover {
  background-color: #352f7a;
}
</style>
